import ReportDataType from '@/constants/api/ReportDataType';

enum ReportType {
  CURRENT_STATE_DASHBOARD = ReportDataType.CURRENT_STATE_DASHBOARD,
  ATTENDEE_LIST = ReportDataType.ATTENDEE_LIST,
  DONATIONS = ReportDataType.DONATIONS,
  DEDICATIONS = ReportDataType.DEDICATIONS,
  GRANTS = ReportDataType.GRANTS,
  LYBUNT = ReportDataType.LYBUNT,
  NEW_DONOR_GROWTH = ReportDataType.NEW_DONOR_GROWTH,
  PLEDGES = ReportDataType.PLEDGES,
  OPPORTUNITIES = ReportDataType.OPPORTUNITIES,
  RECURRING_DONATIONS = ReportDataType.RECURRING_DONATIONS,
  SYBUNT = ReportDataType.SYBUNT,
}

export default ReportType;
